export const internationalPayment = '/international-payment';
export const internationalPaymentCreate = '/international-payment/create';
export const payments = '/payments';
export const paymentsCreate = '/payments/create';
export const c2cPayments = '/c2cpayments';
export const c2cPaymentsCreate = '/c2cpayments/create';
export const depositSend = '/load';
